/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
import React from 'react';
import { useAIThemeColor } from '../styles/theme';
const Loading = props => {
  const aiThemeColor = useAIThemeColor();
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, props.alt), /*#__PURE__*/React.createElement("circle", {
    cx: "5.5",
    cy: "12.5",
    r: "1.5",
    fill: aiThemeColor('loading.step.1')
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "11;13;13;13;13;13;13;11",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: "11.5",
    cy: "10.5",
    r: "1.5",
    fill: aiThemeColor('loading.step.2')
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "11;13;13;13;13;13;13;11",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.2s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: "17.5",
    cy: "12.5",
    r: "1.5",
    fill: aiThemeColor('loading.step.3')
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "11;13;13;13;13;13;13;11",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.4s"
  })));
};
export default Loading;